import { PodcastState } from './types'

const state = (): PodcastState => ({
  activePodcast: null,
})

export default state
